import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { Difference } from '../../../model/src/lib/difference.model';

@Directive({
  selector: '[sigvDetectDifference]',
})
export class DetectDifferenceDirective implements AfterViewInit {
  @Input('sigvDetectDifference')
  difference?: Difference;
  @Input()
  differenceClassName = 'p-text-primary';
  @Input()
  deleteClassName = 'p-text-delete';
  @Input()
  detectDiffTarget = '';

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    if (this.difference) {
      if (this.difference.add) {
        this.el.nativeElement.classList.add(this.differenceClassName);
      } else if (this.difference.delete) {
        this.el.nativeElement.classList.add(this.deleteClassName);
      } else if (this.isDiff()) {
        this.el.nativeElement.classList.add(this.differenceClassName);
      } else if (this.difference.markChange && !this.detectDiffTarget) {
        // 提供標示區塊樣式，表示內容有異動
        // 未指定比較差異之欄位代表應可能為內容有界動之區塊
        this.el.nativeElement.classList.add(this.differenceClassName);
      } else {
        this.el.nativeElement.classList.remove(this.differenceClassName);
        this.el.nativeElement.classList.remove(this.deleteClassName);
      }
    }
  }

  private isDiff(): boolean {
    // 比對差異欄位
    // 名稱不分大小寫
    if (this.detectDiffTarget) {
      if (
        this.difference &&
        this.difference.diffs &&
        this.difference.diffs.length > 0
      ) {
        return this.difference.diffs.some(
          (item) =>
            item.trim().toLowerCase() ===
            this.detectDiffTarget.trim().toLowerCase()
        );
      }
    }
    return false;
  }
}
